import React,{useEffect,useState} from "react";
import api from "../services/api";

export default function TrainersList({setPage}) {
  const [trainers,setTrainers]=useState([]);
  const [search,setSearch]=useState("");

  async function load() {
    try {
      const res=await api.get("/trainers");
      setTrainers(res.data.data||[]);
    } catch(err) {
      console.error(err);
    }
  }
  useEffect(()=>{load();},[]);

  async function remove(id) {
    if(!window.confirm("Delete this trainer?")) return;
    try { await api.delete(`/trainers/${id}`); await load(); }
    catch(err){ alert(err?.response?.data?.message||"Unable to delete trainer"); }
  }

  const rows=trainers.filter(t =>
    `${t.first_name||""} ${t.last_name||""} ${t.email||""}`.toLowerCase().includes(search.toLowerCase())
  );

  return <div style={{padding:"30px"}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
      <h2>Trainers</h2>
      <button style={primaryBtn} onClick={()=>setPage({page:"add-trainer"})}>+ Add Trainer</button>
    </div>
    <div style={card}>
      <input style={input} placeholder="Search trainers" value={search} onChange={e=>setSearch(e.target.value)}/>
    </div>
    <div style={card}>
      <table style={{width:"100%",borderCollapse:"collapse"}}>
        <thead><tr>
          <th style={th}>Name</th><th style={th}>Email</th><th style={th}>Products</th>
          <th style={th}>Status</th><th style={th}>Actions</th>
        </tr></thead>
        <tbody>{rows.map(t=><tr key={t.id}>
          <td style={td}>{t.first_name} {t.last_name}</td>
          <td style={td}>{t.email}</td>
          <td style={td}>{[t.products?.lms?"LMS":null,t.products?.live?"LIVE":null].filter(Boolean).join(" + ")||"-"}</td>
          <td style={td}>{t.status}</td>
          <td style={td}>
            <button style={editBtn} onClick={()=>setPage({page:"edit-trainer",trainerId:t.id})}>Edit</button>
            <button style={deleteBtn} onClick={()=>remove(t.id)}>Delete</button>
          </td>
        </tr>)}</tbody>
      </table>
    </div>
  </div>;
}
const card={background:"#fff",padding:"25px",borderRadius:"8px",boxShadow:"0 2px 10px rgba(0,0,0,.08)",marginBottom:"25px"};
const input={width:"100%",padding:"10px",border:"1px solid #ddd",borderRadius:"6px"};
const primaryBtn={background:"#2c3e50",color:"#fff",border:"none",padding:"10px 16px",borderRadius:"6px",cursor:"pointer"};
const editBtn={background:"#f39c12",color:"#fff",border:"none",padding:"6px 10px",borderRadius:"4px",marginRight:"6px",cursor:"pointer"};
const deleteBtn={background:"#e74c3c",color:"#fff",border:"none",padding:"6px 10px",borderRadius:"4px",cursor:"pointer"};
const th={textAlign:"left",padding:"12px",borderBottom:"1px solid #eee"};
const td={padding:"12px",borderBottom:"1px solid #eee"};
